/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'app/components/common/Loading.jsx';
import Modal from 'app/components/common/Modal.jsx';
import Visibility from 'app/utility/visibility.js';
import axios from 'axios';

class FBGroupModalGIF extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pageVisible: 'visible',
            error: ''
        };

        this.visibilityCallback = this.visibilityCallback.bind(this);

    }

    componentDidMount() {
        Visibility.attach(this.visibilityCallback);
    }

    componentWillUnmount() {
        Visibility.detach(this.visibilityCallback);
    }

    visibilityCallback(nextState) {
        let currentState = this.state.pageVisible;

        if (currentState === 'hidden' && nextState === 'visible') {
            axios(`${this.props.app.config.appUrl}/groupstatus.php?state=${this.props.credID}&id=${this.props.subaccount.id}`)
                .then((response) => {
                    if (response.data.status === 1) {
                        this.props.toggleFooter(true);
                        this.props.toggleModal(false);
                        this.props.closeAllModals();
                    }
                })
                .catch((error) => {
                    this.setState({
                        error: 'An error has occurred trying to add dlvr.it to your Facebook group. Please check your Facebook set up again.'
                    });
                });
        }
        this.setState({
            pageVisible: nextState
        });
    }

    render() {
        let headerContent = "Please add the dlvr.it app to Facebook",
            menuContent = null,
            content = null,
            footerContent = null,
            constants = this.props.app.config.constants,
            imageUrl = this.props.app.config.assetsUrl,
            linkAction = (e) => {
                e.preventDefault();
                window.open("https://www.facebook.com/groups/" + this.props.subaccount.id + "/apps/store");
            },
            closeAction = (e) => {
                this.props.closeAllModals();
                this.props.toggleModal(false);
                this.props.toggleFooter(true);
                this.props.onSubaccountClick({
                    currentTarget: {
                        dataset: {
                            id: this.props.subaccount.id
                        }
                    }
                });
            },
            error = null;

        if (this.state.error) {
            error = (
                <p>{this.state.error}</p>
            );
        }

        content = (
            <div className="fb-group-demo-modal">
                <div className="fb-group-copy">
                    <h2>Please add the dlvr.it app to Facebook</h2>
                    <p>
                        Once you add our app we can post to your group. <a href='https://support.dlvrit.com/hc/en-us/articles/360007690813' target='_blank'>Learn how</a>
                    </p>
                    {error}
                </div>
                <div className="gif-helper">
                    <img id="animated-gif" src={imageUrl + "/images/gif/facebook-groups.gif"} width="100%" height="auto" />
                </div>
                <div className="fb-group-actions">
                    <div className="action-cancel" onClick={closeAction}>cancel</div>
                    <a href="#" onClick={linkAction} target="_blank" className="btn-primary add fixed active">Add dlvr.it app</a>
                </div>
            </div>
        );


        return (
            <Modal
                close={closeAction}
                headerContent={headerContent}
                transparentHeader={true}
                menuContent={menuContent}
                content={content}
                footerContent={footerContent}
                contentClass="fb-group-demo modal-content-padding"
                wrapperClass="opaque"/>
        );
    }
}

FBGroupModalGIF.displayName = "FBGroupModalGIF";

FBGroupModalGIF.propTypes = {

};

FBGroupModalGIF.defaultProps = {

};

export default FBGroupModalGIF;
